export const APPLICATIONS_POLL_MS = 90_000
export const ESSAY_SUMMARY_POLL_MS = 35_000
export const APP_ASSIGNMENTS_POLL_MS = 35_000
export const STARTUP_STAGGER_MS = 200
